import { render } from "./VideoSlider.vue?vue&type=template&id=636bac8e"
import script from "./VideoSlider.vue?vue&type=script&lang=ts"
export * from "./VideoSlider.vue?vue&type=script&lang=ts"

import "./VideoSlider.vue?vue&type=style&index=0&id=636bac8e&lang=stylus"
script.render = render

export default script